import React, { useState, useEffect } from "react";
import "./LoanReportsDetailsModal.scss";
import { TableCell, TableRow, Box, Button, TextField, TableHead, TableBody, Table, TableContainer, Grid, Pagination, CircularProgress, TablePagination, Typography  } from "@mui/material";
import { createLoanPayment, getLoan } from "../../util/API/loandisk";
import { useSelector } from "react-redux";
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { getLoanRepayments } from "../../util/API/loandisk";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import { loanStatusIDs, loanProductIDs } from "../../util/utilfunctions/loandiskMappings";
import { roundInterestRate } from "../../util/utilfunctions/loandiskMappings";
import { commonRunQuery } from "../../util/API/loans";

function LoanReportsDetailsModal({ open, handleClose, loanid }) {
    console.log("loanid-------------",loanid)
    console.log("open-------------",open)
  const [loanInfo, setLoanInfo] = useState(null);
  const [repayments, setRepayments] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState(0.0);
  const [loadingTable, setLoadingTable] = useState(true);
  const [tablePages, setTablePages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [showPaymentButtonText, setShowPaymentButtonText] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [alert, setAlert] = useState(
    {
      severity: '',
      show: false,
      message: '',
      header: ''
    }
  );

  const currentUser = useSelector(
    (state) => state.usersList.selectedUser
  );

  async function getLoanReportDetails() {
    if (!loanid) return;
    let response = await commonRunQuery("263",loanid);
    if (response.data?.header?.callStatus !== "1") {
        return;
    }
    
    let loanDetails = response?.data?.body?.record;
    console.log("loanDetails------------",loanDetails?.loanissued)
    setLoanInfo(loanDetails?.loanissued);

    let paymentsResponse = await commonRunQuery("264",loanid);
    if (paymentsResponse.data?.header?.callStatus !== "1") {
      return;
    }
    let repayments = paymentsResponse?.data?.body?.record;
    if (repayments && !Array.isArray(repayments)) {
      repayments = [repayments];
    }
    console.log("repayments------------",repayments)
    let totalRepaymentPages = Math.ceil(paymentsResponse?.data?.header?.reccount / 6);
    setRepayments(repayments ? repayments : []);

    setTablePages(totalRepaymentPages);
    setLoadingTable(false);
  }

  useEffect(() => {
    setLoadingTable(true);
    getLoanReportDetails();
  }, [loanid]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'rgba(0,0,0, .1)',
      color: theme.palette.common.black,
      fontWeight: 'bold'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 25,
      fontWeight: '600'
    },
  }));

  const handlePageChange = async (page) => {
    setLoadingTable(true);
    setPageNumber(page);
    let response = await getLoanRepayments(loanid, page);
    let apiResponse = response.payload.body.response;
    let repaymentHistory = apiResponse.Results.record
    if (repaymentHistory && !Array.isArray(repayments)) {
      repaymentHistory = [repaymentHistory];
    }
    setRepayments(repaymentHistory);
    setTablePages(Math.ceil(apiResponse.TotalResults) / 6);
    setLoadingTable(false);
  }

  const handlePaymentAmountChange = (event) => {
    setPaymentAmount(event.target.value);
  };

  const StyledTextField = styled(TextField)(({ theme }) => ({
    width: '25%', // Set the width to 90% of the parent
    // marginBottom: theme.spacing(2), // Add some margin at the bottom for spacing
    // '& .MuiInputBase-root': {
    //   fontSize: '1rem', // Customize input font size if needed
    // },
    // '& .MuiInputLabel-root': {
    //   fontSize: '0.9rem', // Customize label font size if needed
    // },
  }));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

  const InfoRow = ({ label, value }) => (
    <Grid item xs={12} sm={6} md={4}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body1" fontWeight="medium">
        {value ?? "-"}
      </Typography>
    </Grid>
  );

  return (
    <BaseDrawer
      open={open}
      handleClose={handleClose}
      height="80vh"
      title="Loan Details"
    >
      <Box sx={{ padding: '20px' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* <Typography variant="h4">Loan Details</Typography> */}
        </Box>
        <Box>
          <div className="loaninfo-container gap-4">
            {/* <Box 
              className="loaninfo-left" 
              sx={{ 
                backgroundColor: '#f9f9f9', 
                p: 3, 
                pb:5,
                borderRadius: 2, 
                boxShadow: 2, 
                mb: 4 
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Loan Summary
              </Typography>
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanInfo?.loanid}
                  label="Loan Request ID"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanInfo?.currcode}
                  label="Loan Currency"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanInfo?.issuedamount}
                  label="Principal Amount"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanInfo?.termtype}
                  label="Loan Type"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanInfo?.fullypaidind == "0" ? "Not Paid" : loanInfo?.fullypaidind == "1" ? "Paid" : "Cancelled"}
                  label="Loan Status"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={`${loanInfo?.issueddate}`}
                  label="Loan Released"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanInfo?.loan_duration_period}
                  label="Interest Period"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={`${loanInfo?.outstandinglatefees}`}
                  label="Late Fees Due"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={`${loanInfo?.outstandingprinciple}`}
                  label="Amount Due"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanInfo?.balance_amount}
                  label="Balance Amount Due"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanInfo?.loanduedate}
                  label="Next Pending Due"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanInfo?.totalamountapplied}
                  label="Total Amount Paid"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
            </Box> */}

          <Box
            className="loaninfo-left"
            sx={{
              backgroundColor: '#f9f9f9',
              p: 3,
              pb: 5,
              borderRadius: 2,
              // boxShadow: 2,
              mb: 4
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
              Loan Summary
            </Typography>

            <Grid container spacing={2}>
              {/* Row 1 */}
              <InfoRow label="Loan Request ID" value={loanInfo?.loanid} />
              <InfoRow label="Loan Currency" value={loanInfo?.currcode} />
              <InfoRow label="Principal Amount" value={loanInfo?.issuedamount} />

              {/* Row 2 */}
              <InfoRow label="Loan Type" value={loanInfo?.termtype} />
              <InfoRow
                label="Loan Status"
                value={
                  loanInfo?.fullypaidind === "0"
                    ? "Not Paid"
                    : loanInfo?.fullypaidind === "1"
                    ? "Paid"
                    : "Cancelled"
                }
              />
              <InfoRow label="Loan Released" value={loanInfo?.issueddate} />

              {/* Row 3 */}
              <InfoRow label="Interest Period" value={loanInfo?.loan_duration_period} />
              <InfoRow label="Late Fees Due" value={loanInfo?.outstandinglatefees} />
              <InfoRow label="Amount Due" value={loanInfo?.outstandingprinciple} />

              {/* Row 4 */}
              <InfoRow label="Balance Amount Due" value={loanInfo?.balance_amount} />
              <InfoRow label="Next Pending Due" value={loanInfo?.loanduedate} />
              <InfoRow label="Total Amount Paid" value={loanInfo?.totalamountapplied} />
            </Grid>
          </Box>

            <div className="loaninfo-right">
              <h3 className="text-center pt-3">Recent Transactions</h3>

              <TableContainer className="loan-report-details-table">
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Payment ID</StyledTableCell>
                      <StyledTableCell>Date</StyledTableCell>
                      <StyledTableCell>Transaction Amount</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingTable ? (
                      <TableRow>
                        <TableCell colSpan={3}>
                          <Grid container justifyContent="center" alignItems="center">
                            <span className="loader" />
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ) : repayments && repayments.length > 0 ? (
                      repayments
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => (
                          <TableRow key={row.repayment_id}>
                            <TableCell align="left">
                              {row?.loanpayments?.paymentid}
                            </TableCell>
                            <TableCell align="left">
                              {row?.loanpayments?.paymentdate}
                            </TableCell>
                            <TableCell align="right">
                              {row?.loanpayments?.paymentamount}
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          <Box sx={{ mt: 2 }}>
                            <span style={{ color: "gray", fontSize: "1rem" }}>
                              No data available
                            </span>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={repayments?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
              </Box>
            </div>

          </div>
        </Box>
      </Box>
      <CustomAlert 
        severity={alert.severity} 
        show={alert.show} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prevDetails) => setAlert({...prevDetails, showAlert: false})} 
        autoclose={alert.severity === "error" ? false : true} 
      />
    </BaseDrawer>

  );
}

export default LoanReportsDetailsModal;
